import React, { useEffect } from "react";
import Seo from "components/Seo";
import { useNavigate } from "react-router-dom";
import { useGetAlarm } from "hooks/morning/useGetAlarm";
import { ReactComponent as ArrowBack } from "assets/common/common/arrowBack.svg";

export default function MyPageAlarm() {
    const navigate = useNavigate();
    const { data: alarmData } = useGetAlarm();

    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);

    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="마이페이지" />
            <div className="bg-white min-h-[100dvh] flex fixed z-[88888] inset-0 overflow-hidden">
                <div className="w-full max-w-[680px] mx-auto flex flex-col border-l border-r border-[#dddddd] responsive650:border-none">
                    <div className="relative text-[#262A34] text-[20px] text-center font-[500] py-[16px] border-b">
                        알림
                        <ArrowBack onClick={() => navigate(-1)} className="absolute top-1/2 -translate-y-1/2 left-[16px]" />
                    </div>
                    <div className="overflow-y-auto flex-1 flex flex-col">
                        {alarmData && alarmData?.length > 0 ? (
                            <>
                                {alarmData.map(alarm => {
                                    return (
                                        <div key={alarm.bl_no} className="p-[4%] border-b">
                                            <p className="text-[#1B1C1E] mb-[8px]">{alarm.bl_no}</p>
                                            <p className="text-[#666666] mb-[4px]">{alarm.o_kind_text}</p>
                                            <p className="text-[#878A93] text-[14px]">{alarm.o_date}</p>
                                        </div>
                                    );
                                })}
                            </>
                        ) : (
                            <div className="text-center py-[50px]">알림 내역 없음</div>
                        )}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
